import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {MENU_ITEMS} from 'src/app/app.constants';

import {getRolePermissionByKey} from 'src/app/shared/directives/utils/get-role-permission-by-key';
import {selectActiveUserRole} from '../store/active-user/active-user.selector';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionsGuard implements CanActivate, CanLoad {
  constructor(
    private store: Store,
    private router: Router
  ) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | boolean {
    return this.checkUserRolePermissions(route, null);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean {
    return this.checkUserRolePermissions(route, state);
  }

  checkUserRolePermissions(route: Route | ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.select(selectActiveUserRole).pipe(
      filter(role => !!role),
      map(role => {
        const roleDisplayName = role.displayName?.toLowerCase();
        if (roleDisplayName === 'admin') return true;

        const rolePermissions = role.permissions;
        const currentUrl = state.url;

        const menuItem = MENU_ITEMS.find(item => item.url === currentUrl);
        if (menuItem?.adminOnly && roleDisplayName !== 'admin') {
          this.router.navigate(['/current-sked']);
          return false;
        }

        if (!menuItem?.rolePermissionKey) return true;
        const permission = getRolePermissionByKey(rolePermissions, menuItem.rolePermissionKey);
        const isActive = permission.active;
        if (!isActive) {
          this.router.navigate(['/current-sked']);
          return false;
        }
        return true;
      })
    );
  }
}
